import React, { forwardRef } from 'react';
import cm from 'classnames';
import styles from '../_input.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  alert?: boolean;
}

const InputArea = forwardRef<HTMLTextAreaElement, Props>((props: Props, ref) => {
  const { className, alert, ...rest } = props;
  const finalClassName = [styles.InputArea];
  if (className) finalClassName.push(className);
  if (alert) finalClassName.push(styles['InputArea--alert']);
  return <textarea {...rest} ref={ref} className={cm(finalClassName)} />;
});
InputArea.displayName = 'InputArea';

export { InputArea };
